export const STORE_LOCATION_SELECTED = 'You have selected the store below. Click Next to proceed or search for another store.'
